<template>
  <Dialog :visible.sync="dialogVisible" @close="closedDialog">
    <div class="pay-dialog">
      <slot>

      </slot>
      <section class="pay-container" :class="{'no-slot': noSlot}">
        <div>
          支付方式
        </div>
        <div class="pay-type">
          <div class="pay-item ">
            <img v-show="payCode && !reGenFlag" :src="payCode" alt="" srcset="">
            <div v-show="reGenFlag" @click="reGen" class="re-gen">
              <div class="gen-tip">二维码超时</div>
              <div class="gen-tip">请点击刷新</div>
            </div>
          </div>
          <span>微信扫码支付</span>
        </div>
        <div class="pay-type">
          <div class="pay-item pay-item-right" @click="payWithWallet">
            <svg-icon name="wallet_color"></svg-icon>
            <div class="remainder">
              <div>可用余额</div>
              <span :class="{active: walletInfo.balance}">{{walletInfo.balance}}元</span>
            </div>
          </div>
          <span>钱包余额支付</span>
        </div>
      </section>
      <section class="bottom">
        <div class="bottom-left">
          <span>应付金额</span> <span class="unit">￥</span> <span class="money">{{money}}
            <Tooltip class="discount" v-if="promote">已优惠￥{{promote}}</Tooltip>
          </span>
        </div>
        <div class="be-vip" v-if="!userInfo.role">
          <img src="@/assets/images/vip_button.png" alt="" srcset="">
          <!-- <Tooltip>新人礼</Tooltip> -->
        </div>
      </section>
    </div>
  </Dialog>
</template>

<script>
import Dialog from './svoice-dialog'
import Tooltip from '@/components/tooltip.vue'
import { payWithWallet, payWithNativePay } from '@/api/pay'
import { checkNativeOrderStatus } from '@/api/order'

export default {
  name: 'pay-dialog',
  components: {
    Dialog,
    Tooltip
  },
  props: {
    vip: Boolean,
    money: Number,
    promote: Number,
    tradeNo: String,
    noSlot: Boolean,
    payVisible: Boolean
  },
  data() {
    return {
      dialogVisible: false,
      payCode: '',
      count: 0,
      reGenFlag: false,
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.global.userInfo
    },
    walletInfo () {
      return this.$store.state.global.walletInfo
    }
  },
  watch: {
    tradeNo(val) {
      if (!val) {
        return
      }
      this.payWithNativePay(val)
    },
    payVisible (val) {
      if (!val || !this.tradeNo) {
        return
      }
      this.payWithNativePay(this.tradeNo)
    }
  },
  created() {
    this.dialogVisible = true
  },
  methods: {
    reGen () {
      this.reGenFlag = false
      this.payWithNativePay(this.tradeNo)
    },
    async payWithNativePay (trade_no) {
      clearInterval(this.timer)
      const res = await payWithNativePay({
        trade_no
      })
      if (res.code !== 0) {
        return
      }
      this.payCode = location.origin + process.env.VUE_APP_BASE_API + res.data.native_code_image_url
      this.timer = setInterval(()=> {
        this.count++
        if (this.count === 60) {
          clearInterval(this.timer)
          this.count = 0
          this.reGenFlag = true
          return
        }
        this.checkNativeOrderStatus(trade_no)
      }, 1000)
    },
    async checkNativeOrderStatus (trade_no) {
      const res = await checkNativeOrderStatus({
        trade_no
      })
      console.log(res.data, 'checkNativeOrderStatus')
      if (res.data.is_paid) {
        clearInterval(this.timer)
        this.$toast('微信支付成功')
        this.jumpVip()
      }
    },
    closedDialog () {
      console.log('closedDialog')
      this.$emit('close')
      this.dialogVisible = false
      this.timer&&clearInterval(this.timer)
      this.payCode  = ''
    },
    async payWithWallet () {
      clearInterval(this.timer)
      const res = await payWithWallet({ trade_no: this.tradeNo })
      console.log(res.data)
      if (res.code !== 0) {
        this.$toast(res.msg || '余额支付失败，请重新支付')
      } else {
        this.$toast('余额支付成功')
        this.jumpVip()
      }
    },
    jumpVip () {
      this.$router.push({path: '/personal/vip'});
      this.$emit('close', 'paid')
      this.$store.dispatch('global/setWalletInfo')
      this.$store.dispatch('global/setUserInfo')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pay-dialog {
  width: 600px;
  padding: 30px;
  box-sizing: border-box;
  font-size: 14px;
  color: #555555;
  .pay-container {
    display: flex;
    margin-bottom: 48px;
    padding-top: 20px;
    border-top: 1px solid #EEEEEE;
    &.no-slot {
      border: none;
    }
    .pay-type {
      flex: 1;
      text-align: center;
      .pay-item {
        width: 120px;
        height: 120px;
        margin: 0 auto;
        margin-bottom: 10px;
        .re-gen {
          height: 120px;
          background: rgba($color: #000000, $alpha: 0.8);
          color: #fff;
          cursor: pointer;
          .gen-tip:first-child {
            padding-top: 30px;
          }
          .gen-tip {
            margin-top: 10px;
          }
        }
        img {
          width: 120px;
          height: 120px;
        }
      }
      .pay-item-right {
        width: 118px;
        height: 118px;
        background: #F4F7FB;
        border: 1px solid #E1EEFF;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .svg-icon {
          width: 40px;
          height: 40px;
          flex: 1;
        }
        .remainder {
          padding-bottom: 10px;
          color: #999999;
          font-size: 14px;
          .active {
            color: #4E6EFF;
          }
        }
      }

    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .bottom-left {
      display: flex;
      align-items: flex-end;
    }
    .be-vip {
      position: relative;
    }
    .unit {
      margin-left: 10px;
      font-size: 16px;
    }
    .money {
      margin-left: 5px;
      font-size: 36px;
      color: #555555;
      line-height: 30px;
      position: relative;
      .discount {
        top: 0;
        transform: translate(90%, -90%);
      }
    }
  }
}
 
</style>
